export { default as KuperBannerSecond } from './KuperBannerSecond'
